import { Params } from "./types";

export const flatten = <T>(data: Record<number, T[]>) =>
  Object.values(data).flat();

export const containsPayload = (params: Params) =>
  Object.keys(params).length > 2;
